import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { TextField, PhoneField } from './../../fields';
import { required, email } from '../../../utilities/validation';
import messages from '../../../text/messages';

class ContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { handleSubmit, hideControls, cancel, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="address-fields col-xs-12">
                        <div className="col-xs-6">
                            <Field name="firstName" validate={required} component={TextField} placeholder={messages.firstName} />
                        </div>
                        <div className="col-xs-6">
                            <Field name="lastName" validate={required} component={TextField} placeholder={messages.lastName} />
                        </div>
                        <div className="col-xs-12">
                            <Field name="email" validate={[required, email]} component={TextField} placeholder={messages.email} />
                        </div>
                        <div className="col-xs-12">
                            <Field name="phone" component={PhoneField} placeholder={messages.phoneNumber} />
                        </div>

                        {hideControls !== true && (
                            <div className="col-xs-12">
                                {cancel && (
                                    <button className="pull-left" type="button" onClick={cancel} disabled={submitting}>
                                        <FormattedMessage {...messages.cancel} />
                                    </button>
                                )}
                                <button className="pull-right" type="submit" disabled={submitting}>
                                    <FormattedMessage {...messages.submit} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        );
    }
}

ContactForm.defaultProps = {
    handleSubmit: undefined,
    hideControls: false
};

ContactForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    hideControls: PropTypes.bool
};

export default reduxForm({
    destroyOnUnmount: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true
})(ContactForm);



// WEBPACK FOOTER //
// ./src/components/forms/contact/index.jsx